import { advertiserInsertionOrdersRequests } from '@shared/mocks/requests/advertiserInsertionOrders/advertiserInsertionOrders';
import { advertisersRequests } from '@shared/mocks/requests/advertisers/advertisers';
import { agenciesRequests } from '@shared/mocks/requests/agencies/agencies.ts';
import { aiSummaryRequests } from '@shared/mocks/requests/aiSummary/aiSummary';
import { billingContactsRequests } from '@shared/mocks/requests/billingContacts/billingContacts';
import { brandsRequests } from '@shared/mocks/requests/brands/brands';
import { campaignDeleteRequests } from '@shared/mocks/requests/campaignDelete/campaignDelete.ts';
import { campaignDetailsRequests } from '@shared/mocks/requests/campaignDetails/campaignDetails';
import { campaignsListRequests } from '@shared/mocks/requests/campaignsList/campaignsList';
import { campaignSubmitRequests } from '@shared/mocks/requests/campaignSubmit/campaignSubmit';
import { creatableMediaTypesRequests } from '@shared/mocks/requests/creatableMediaTypes/creatableMediaTypes';
import { campaignCreateRequests } from '@shared/mocks/requests/createCampaign/createCampaign';
import { creativesRequests } from '@shared/mocks/requests/creatives/creatives';
import { exportOneflightRequests } from '@shared/mocks/requests/exportOneflight/exportOneflight.ts';
import { highImpactCreativesRequests } from '@shared/mocks/requests/highImpactCreatives/highImpactCreatives';
import { oneflightBrandsRequests } from '@shared/mocks/requests/oneflightBrands/oneflightBrands.ts';
import { oneflightClientsRequests } from '@shared/mocks/requests/oneflightClients/oneflightClients.ts';
import { pricingRequests } from '@shared/mocks/requests/pricing/pricing';
import { reportingRequests } from '@shared/mocks/requests/reporting/reporting';
import { targetingRequests } from '@shared/mocks/requests/targeting/targeting';
import { thematicPackagesRequests } from '@shared/mocks/requests/thematicPackages/thematicPackages';
import { updateCampaignRequests } from '@shared/mocks/requests/updateCampaign/updateCampaign';
import { userProfileRequests } from '@shared/mocks/requests/userProfile/userProfile';

export const handlers = [
  // Before campaignDetailsRequests, whose `*/campaigns/:id` would capture `/campaigns/media-types`
  ...creatableMediaTypesRequests,
  ...campaignsListRequests,
  ...campaignSubmitRequests,
  ...campaignDetailsRequests,
  ...advertisersRequests,
  ...advertiserInsertionOrdersRequests,
  ...brandsRequests,
  ...agenciesRequests,
  ...campaignCreateRequests,
  ...creativesRequests,
  ...highImpactCreativesRequests,
  ...pricingRequests,
  ...billingContactsRequests,
  ...reportingRequests,
  ...updateCampaignRequests,
  ...targetingRequests,
  ...campaignDeleteRequests,
  ...oneflightClientsRequests,
  ...oneflightBrandsRequests,
  ...exportOneflightRequests,
  ...userProfileRequests,
  ...aiSummaryRequests,
  ...thematicPackagesRequests,
];
